export function removeBlankInText(text: string) {
  return text.replace(/\s+/g, '');
}
